<template>
  <div class="flex-center-column home-condition">
    <div class="title-zh">入驻条件</div>
    <div class="title-en">ENTRY CONDITIONS</div>
    <div class="flex-row-space-between-hCenter condition-list">
      <div class="flex-column-center condition-item">
        <img src="@/assets/home/condition_1.png" alt="">
        <span class="dec">登录账号状态正常</span>
        <span class="dec">并且登录账号已绑定手机号</span>
      </div>
      <div class="flex-center-column condition-item">
        <img src="@/assets/home/condition_2.png" alt="">
        <span class="dec">机构签约达人数量至少5个，并与MCN机构签署合同，达人帐号需实名认证</span>
      </div>
      <div class="flex-center-column condition-item">
        <img src="@/assets/home/condition_3.png" alt="">
        <span class="dec">MCN过往无违规行为，同一营业执照下，只允许一个MCN主体入驻</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-condition"
}
</script>

<style lang="scss" scoped>
.home-condition {
  width: 1200px;
  margin: 64px auto 0;
  padding: 32px 0;

  .title-zh {
    position: relative;
    color: #1d2129;
    font-size: 24px;
    line-height: 32px;
    z-index: 1;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 8px;
      background: url("~@/assets/home/title_decoration.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      z-index: -1;
    }
  }

  .title-en {
    color: #86909c;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-top: 8px;
  }

  .condition-list {
    width: 1000px;
    margin-top: 24px;

    .condition-item {
      width: 300px;
      height: 184px;
      padding: 24px;
      background: #fff;
      box-shadow: 0 2px 5px #0000001a;
      text-align: center;

      img{
        width: 80px;
        height: 80px;
      }

      .dec{
        color: #1d2129;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 12px;
      }
    }
  }
}
</style>